import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadLink, leadLinksManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const LEAD_LINK_MODULE = 'leadlinks';

const dataObjectModule = getDataObjectsModule<ILeadLink>(leadLinksManager, 0);
const searchModule = getSearchModule<ILeadLink>(leadLinksManager);

const leadLinkModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(LEAD_LINK_MODULE, leadLinkModuleInstance);

export { LEAD_LINK_MODULE };
